import { select, takeEvery } from 'redux-saga/effects';
import { BasketActionTypes } from '../../../enums/ActionEnums';
import { emitter, EmitterEvent } from '../../../util/emitter';
import { buildCartUpdatePayload } from '../../../util/TrackingUtil';
/**
 * Reads product details from Redux product state (PDP).
 */
const getProductDetails = (state) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    const { product } = state;
    const selectedColor = (_a = product.productColorVariations) === null || _a === void 0 ? void 0 : _a.find(c => c.colorId === product.selectedColorId);
    const selectedSize = (_b = selectedColor === null || selectedColor === void 0 ? void 0 : selectedColor.sizes) === null || _b === void 0 ? void 0 : _b.find((s) => s.sku === product.selectedSku);
    return {
        productId: product.productId,
        brand: (_d = (_c = product.brand) === null || _c === void 0 ? void 0 : _c.description) !== null && _d !== void 0 ? _d : '',
        title: (_f = (_e = product.productTranslatedProperties) === null || _e === void 0 ? void 0 : _e.title) !== null && _f !== void 0 ? _f : '',
        colour: (_g = selectedColor === null || selectedColor === void 0 ? void 0 : selectedColor.color) !== null && _g !== void 0 ? _g : '',
        colourCode: (_h = selectedColor === null || selectedColor === void 0 ? void 0 : selectedColor.colorCode) !== null && _h !== void 0 ? _h : '',
        size: (_j = selectedSize === null || selectedSize === void 0 ? void 0 : selectedSize.fullCommercialSize) !== null && _j !== void 0 ? _j : '',
        price: (_l = (_k = selectedColor === null || selectedColor === void 0 ? void 0 : selectedColor.prices) === null || _k === void 0 ? void 0 : _k.SELL) === null || _l === void 0 ? void 0 : _l.original,
        buyingGroup: product.buyingGroup,
        gender: (_m = product.gender) !== null && _m !== void 0 ? _m : '',
    };
};
const getBasketMappedProducts = (state) => { var _a, _b; return (_b = (_a = state.basket) === null || _a === void 0 ? void 0 : _a.mappedProducts) !== null && _b !== void 0 ? _b : []; };
const getBasketTotalQuantity = (state) => { var _a, _b; return (_b = (_a = state.basket) === null || _a === void 0 ? void 0 : _a.totalQuantity) !== null && _b !== void 0 ? _b : 0; };
const DEFAULT_PRICING = {
    priceDelivery: 0,
    priceTotalBasket: 0,
    totalBasketDiscountAmount: 0,
    totalPriceSell: 0,
    totalPriceSellBeforeDiscount: 0,
};
const getBasketPricing = (state) => { var _a, _b; return (_b = (_a = state.basket) === null || _a === void 0 ? void 0 : _a.pricing) !== null && _b !== void 0 ? _b : DEFAULT_PRICING; };
function* handleCartUpdate(action) {
    try {
        const isAdd = action.type === BasketActionTypes.ADD_SUCCESS;
        const { product } = action.payload;
        const productDetails = yield select(getProductDetails);
        const mappedProducts = yield select(getBasketMappedProducts);
        const totalQuantity = yield select(getBasketTotalQuantity);
        const pricing = yield select(getBasketPricing);
        emitter.emit(EmitterEvent.CART_UPDATE, buildCartUpdatePayload(isAdd ? 'add' : 'remove', {
            productId: productDetails.productId,
            sku: product.sku,
            quantity: product.quantity,
            price: productDetails.price,
            brand: productDetails.brand,
            title: productDetails.title,
            colour: productDetails.colour,
            colourCode: productDetails.colourCode,
            size: productDetails.size,
            buyingGroup: productDetails.buyingGroup,
            gender: productDetails.gender,
        }, mappedProducts, totalQuantity, pricing));
    }
    catch (_a) {
        // Don't block basket flow if tracking fails
    }
}
export function* cartUpdateTrackingSaga() {
    yield takeEvery([BasketActionTypes.ADD_SUCCESS, BasketActionTypes.REMOVE_PRODUCT_SUCCESS], handleCartUpdate);
}
